import React, { Component } from 'react';
import Option from './Option';

class Optgroup extends Component {
	render() {
		return (
			<optgroup label={this.props.name}>
				{this.props.options.map((option) =>
					<Option key={option.value} value={option.value} name={option.name} />
				)}
			</optgroup>
		);
	}
}

export default Optgroup;
